import { useLayoutEffect, useState } from "react";

const PLATFORM_SUBDOMAINS = new Set(["admin", "www", "app"]);

const useDomain =(mainDomain: string) => {
  const [subdomain, setSubdomain] = useState(null);

  useLayoutEffect(() => {
    const hostname = window.location.hostname;
    let sub = null;

    if (mainDomain) {
      if (hostname !== mainDomain && hostname.endsWith(`.${mainDomain}`)) {
        sub = hostname.replace(`.${mainDomain}`, "");
      }
    } else {
      const parts = hostname.split(".");
      if (parts.length > 2) {
        sub = parts[0];
      }
    }

    if (sub) {
      setSubdomain(sub);
    }
  }, [mainDomain]);

  // Platform hosts, never a workspace: `app.` is the main sign-in entry.
  const orgDomain =
    subdomain && !PLATFORM_SUBDOMAINS.has(subdomain)
      ? `${subdomain}.${mainDomain}`
      : "";

  return {
    subdomain,
    orgDomain: orgDomain,
    isAdmin: subdomain === "admin",
  };
};

export default useDomain;
